import './podcast.css';

// Sección 06 — "Podcast · Inge Chingón". Player del show + intro y carrusel de
// episodios paginado (3 por página, prev/next). Embeds REALES de Spotify (show
// 7HMUJJX8… + 5 episodios). Iframes con loading="lazy" (no cargan hasta llegar).
// Fiel al .dc.html y su lógica DCLogic.

const SHOW_ID = '7HMUJJX8fj12rqvFlSIlQx';
const SHOW_URL = `https://open.spotify.com/show/${SHOW_ID}`;
const YT_URL = 'https://www.youtube.com/@juliopasosoficial';
const EPISODE_IDS = [
  '1OQoO7DVRIT6IOXKenpgy7',
  '53SnjpKaFxIf3IiCZ2QrXF',
  '2fqT8IaEmuUiGzwMAjqFV5',
  '68AVvZiS9Eqb9PJCC74EoQ',
  '3t3pz0OiGu3sFef8jTqjbF',
];
const PER = 3;
const embedSrc = (id) => `https://open.spotify.com/embed/episode/${id}/video?utm_source=generator&theme=0`;

// Los cuatro embeds de Spotify cargan DIRECTO, sin fachada de por medio.
//
// Se probó ponerlos tras un clic para no plantar cookies de terceros antes de
// que nadie lo pida —es lo que marca Lighthouse— y Julio lo descartó: el
// podcast es de las piezas que más convierten y pedir un clic extra para oírlo
// le quita la gracia. Queda como decision de producto, no como descuido: el
// costo es un punto de Best Practices y tres cookies de open.spotify.com.
//
// `loading="lazy"` se queda porque la sección vive abajo del home: al menos no
// cargan hasta que el visitante se acerca.
const embed = (src, titulo) => `
  <iframe title="${titulo}" src="${src}" loading="lazy" frameborder="0" allowfullscreen
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>`;

const SPOTIFY_ICON = `<svg width="17" height="17" viewBox="0 0 24 24" fill="#fff"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm4.6 14.4a.78.78 0 01-1.07.26c-2.93-1.79-6.62-2.2-10.97-1.2a.78.78 0 11-.35-1.52c4.76-1.09 8.85-.62 12.13 1.39.37.23.49.71.26 1.07zm1.23-2.74a.97.97 0 01-1.34.32c-3.35-2.06-8.46-2.66-12.42-1.45a.97.97 0 11-.57-1.86c4.53-1.37 10.16-.7 14.01 1.66.46.28.6.88.32 1.33zm.11-2.86C14.13 8.42 7.7 8.2 4.27 9.24a1.17 1.17 0 01-.68-2.23c3.94-1.2 11.04-.94 15.4 1.65a1.17 1.17 0 01-1.19 2.01z"/></svg>`;
const ARROW_L = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8l5 5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const ARROW_R = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3l5 5-5 5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

function markup() {
  const ensoBig = `<svg class="zk-podcast__enso" viewBox="0 0 200 200" aria-hidden="true"><circle cx="100" cy="100" r="84" fill="none" stroke="#AE1F23" stroke-width="16" stroke-linecap="round" stroke-dasharray="464 700" transform="rotate(48 100 100)"/><circle cx="100" cy="100" r="64" fill="none" stroke="#AE1F23" stroke-width="8" stroke-linecap="round" stroke-dasharray="156 700" transform="rotate(202 100 100)"/></svg>`;
  const ensoSm = `<svg viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="50" r="42" fill="none" stroke="#AE1F23" stroke-width="10" stroke-linecap="round" stroke-dasharray="232 400" transform="rotate(48 50 50)"/><circle cx="50" cy="50" r="31" fill="none" stroke="#AE1F23" stroke-width="5" stroke-linecap="round" stroke-dasharray="76 400" transform="rotate(202 50 50)"/></svg>`;
  return `
  <div class="zk-podcast__glow zk-podcast__glow--red" aria-hidden="true"></div>
  ${ensoBig}

  <div class="zk-podcast__top">
    <div class="zk-podcast__player" data-reveal>
      <div class="zk-podcast__player-inner">
        ${embed(`https://open.spotify.com/embed/show/${SHOW_ID}/video?utm_source=generator&theme=0`, 'Inge Chingón en Spotify')}
      </div>
    </div>
    <div class="zk-podcast__intro">
      <div class="zk-podcast__eyebrow" data-reveal>${ensoSm}<span>El podcast</span></div>
      <!-- El "#1 en LATAM" era un superlativo sin fuente: si alguien lo discute no
     hay con qué sostenerlo. El copy v2 lo cambia por una invitación, que además
     encaja mejor en esta posición de la página —después del precio—. -->
      <h2 class="zk-podcast__h2" data-reveal>&iquest;Todav&iacute;a no te convences? <span class="c">Escucha primero.</span></h2>
      <div class="zk-podcast__wordmark" data-reveal>Inge Chingón</div>
      <p class="zk-podcast__desc" data-reveal>Cada semana Julio Pasos platica con <b>los ingenieros y líderes que ya llegaron</b>: cómo entraron a las juntas que importan, qué decisiones aceleraron su carrera y qué harían distinto. Sin teoría de manual &mdash;conversaciones que puedes aplicar el lunes.</p>
      <div class="zk-podcast__actions" data-reveal>
        <a class="zk-podcast__btn zk-podcast__btn--spotify" href="${SHOW_URL}" target="_blank" rel="noopener">${SPOTIFY_ICON}Escuchar en Spotify</a>
        <a class="zk-podcast__btn zk-podcast__btn--yt" href="${YT_URL}" target="_blank" rel="noopener">Ver en YouTube</a>
      </div>
    </div>
  </div>

  <div class="zk-podcast__eps">
    <div class="zk-podcast__eps-head" data-reveal>
      <div>
        <div class="t">Últimos episodios</div>
        <div class="zk-podcast__range" data-range></div>
      </div>
      <div class="zk-podcast__nav">
        <button type="button" class="zk-podcast__arrow zk-podcast__arrow--prev" aria-label="Episodios anteriores">${ARROW_L}</button>
        <button type="button" class="zk-podcast__arrow zk-podcast__arrow--next" aria-label="Episodios siguientes">${ARROW_R}</button>
      </div>
    </div>
    <div class="zk-podcast__grid" data-reveal></div>
  </div>`;
}

/**
 * Monta la sección de Podcast dentro de `mount`.
 * @returns {HTMLElement} la <section> montada.
 */
export function mountPodcast(mount) {
  const section = document.createElement('section');
  section.className = 'zk-podcast';
  section.id = 'podcast';
  section.setAttribute('aria-label', 'Podcast Inge Chingón');
  section.innerHTML = markup();
  (mount || document.body).appendChild(section);

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- Carrusel de episodios (paginado, 3 por página) ----
  const grid = section.querySelector('.zk-podcast__grid');
  const range = section.querySelector('[data-range]');
  const prev = section.querySelector('.zk-podcast__arrow--prev');
  const next = section.querySelector('.zk-podcast__arrow--next');
  const totalPages = Math.max(1, Math.ceil(EPISODE_IDS.length / PER));
  let page = 0;

  function render() {
    const start = page * PER;
    const slice = EPISODE_IDS.slice(start, start + PER);
    grid.innerHTML = slice.map((id, i) => `
      <div class="zk-podcast__ep" style="animation-delay:${reduced ? 0 : i * 90}ms">
        <div class="zk-podcast__ep-inner">
          ${embed(embedSrc(id), `Episodio ${start + i + 1} de Inge Chingón`)}
        </div>
      </div>`).join('');
    range.textContent = `${start + 1}–${Math.min(start + PER, EPISODE_IDS.length)} de ${EPISODE_IDS.length} episodios`;
    prev.classList.toggle('is-disabled', page <= 0);
    next.classList.toggle('is-disabled', page >= totalPages - 1);
  }
  prev.addEventListener('click', () => { if (page > 0) { page--; render(); } });
  next.addEventListener('click', () => { if (page < totalPages - 1) { page++; render(); } });
  render();

  // ---- Entrada escalonada ----
  const revealEls = [...section.querySelectorAll('[data-reveal]')];
  if (reduced) { section.classList.add('is-in'); return section; }
  section.classList.add('is-fx');
  revealEls.forEach((el, i) => { el.style.transitionDelay = `${Math.min(i * 70, 560)}ms`; });
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { section.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.1 });
    io.observe(section);
  } else {
    section.classList.add('is-in');
  }

  return section;
}
